module.exports = __webpack_public_path__ + "img/policiesBanner.bcb3e8ee.png";